import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import getLocaleDate from '../../utils/getLocaleDate';

export const GradeDescription = ({ isGraded, isReturned, selectedStudent }) => {
  const { t, i18n } = useTranslation();
  return (
    <>
      {isGraded &&
        !isReturned && (
          <div>
            <span>
              {t('Evaluated on {{DATE}}', {
                DATE: getLocaleDate({
                  date: selectedStudent.submission.evaluatedOn,
                  language: i18n.language,
                }),
              })}
            </span>
          </div>
        )}
      {isReturned && (
        <div>
          <span>
            {t('Returned on {{DATE}}', {
              DATE: getLocaleDate({
                date: selectedStudent.submission.returnedOn,
                language: i18n.language,
              }),
            })}
          </span>
        </div>
      )}
    </>
  );
};

GradeDescription.propTypes = {
  isGraded: PropTypes.bool.isRequired,
  isReturned: PropTypes.bool.isRequired,
  selectedStudent: PropTypes.object.isRequired,
};
